import { Card, Typography } from 'antd'
import React from 'react'
import { PageInfo } from '../types'
import './Overview.less'

const { Text, Title } = Typography

interface OverviewProps {
  pageInfo?: PageInfo
}

const Overview: React.FC<OverviewProps> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pageInfo,
}) => {
  return (<>
    <Card
      title={  <Title style={titleStyle} level={3}>平台概述</Title>}
      className="overview"
    >
      <Card.Grid
        style={gridStyle}
        hoverable={false}
      >
        <OverviewItem
          title="产品数"
          count={pageInfo?.product.total}
          infoList={[
            { title: '已发布', value: `${pageInfo?.product.release_total}个` },
            { title: '未发布', value: `${pageInfo?.product.unreleased_total}个` },
          ]}
        />
      </Card.Grid>
      <Card.Grid
        style={gridStyle}
        hoverable={false}
      >
        <OverviewItem
          title="设备数"
          count={pageInfo?.device.total}
          infoList={[
            { title: '在线', value: `${pageInfo?.device.online_total}个` },
            { title: '离线', value: `${pageInfo?.device.offline_total}个` },
          ]}
        />
      </Card.Grid>
      <Card.Grid
        style={gridStyle}
        hoverable={false}
      >
        <OverviewItem
          title="驱动数"
          count={pageInfo?.driverInstance.count}
          infoList={[
            { title: '运行中', value: `${pageInfo?.driverInstance.run_count}个` },
            { title: '已停止', value: `${pageInfo?.driverInstance.stop_count}个` },
          ]}
        />
      </Card.Grid>
      <Card.Grid
        style={gridStyle}
        hoverable={false}
      >
        <OverviewItem
          title="告警数"
          count={pageInfo?.alert.total}
          infoList={[
            { title: '数据统计截止昨日24时', value: ' ' },
          ]}
        />
      </Card.Grid>
    </Card>
  </>)
}

interface OverviewItemProps {
  title?: string
  count?: number
  infoList?: { title: string, value?: string }[]
}

const gridStyle: React.CSSProperties = {
  width: '25%',
  marginTop: '10px',
}

const titleStyle: React.CSSProperties = {
  marginTop: '20px',
}


const OverviewItem: React.FC<OverviewItemProps> = (props) => {
  return (
    <div className="overview-item flex flex-vertical justify-space-between" style={{ marginTop: '-20px' }}>
      <div>
        <div className="overview-item__title">{props.title}</div>
        <div className="overview-item__count">{props.count}</div>
      </div>
      <div>
        {(props.infoList || []).map(({ title, value }) => (
          <Text
            className="overview-item__info flex flex-horizontal justify-space-between"
            key={title}
          >
            <span>{title}</span>
            <span>{value}</span>
          </Text>
        ))}
      </div>
    </div>
  )
}

export default Overview
